"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SortDirection = require("./common/SortDirection");
var _TableBody = _interopRequireDefault(require("./body/TableBody"));
var _TableHeader = _interopRequireDefault(require("./header/TableHeader"));
require("./table.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Table = exports.Table = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    mt = 8,
    className,
    headerContent,
    bodyContent,
    lookupTextFunction,
    shouldAutoScroll = false,
    onScrollComplete,
    sortConfig,
    onExpandedRow,
    onHeaderClick
  } = _ref;
  const targetRowRef = (0, _react.useRef)(null);
  const constructInitialState = (sortableColumns, defaultSortColumn) => {
    return Object.fromEntries(sortableColumns.map(column => {
      const {
        columnKey,
        defaultSortDirection = _SortDirection.SortDirection.ASCENDING
      } = column;
      return [columnKey, defaultSortColumn === columnKey ? defaultSortDirection : _SortDirection.SortDirection.NONE];
    }));
  };
  const [orderBy, setOrderBy] = (0, _react.useState)(constructInitialState((sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.sortableColumns) || [], sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.defaultSortColumn));
  const [targetRowIndex, setTargetRowIndex] = (0, _react.useState)(-1);
  const sortedData = (0, _react.useMemo)(() => {
    return sortConfig ? sortConfig.onSort([...bodyContent], orderBy) : bodyContent;
  }, [bodyContent, orderBy, sortConfig]);
  (0, _react.useEffect)(() => {
    if (targetRowRef.current && targetRowRef.current.classList.contains("highlighted") && shouldAutoScroll) {
      targetRowRef.current.scrollIntoView({
        behavior: "smooth"
      });
      onScrollComplete && onScrollComplete();
    }
  }, [targetRowIndex, shouldAutoScroll, onScrollComplete]);
  (0, _react.useEffect)(() => {
    if (sortedData && Array.isArray(sortedData)) {
      const scrollToIndex = sortedData.findIndex(value => value.highlightRow);
      setTargetRowIndex(scrollToIndex);
    }
  }, [sortedData]);
  const handleClick = columnName => {
    function findDefaultSortDirection() {
      var _sortConfig$sortableC;
      return (sortConfig === null || sortConfig === void 0 || (_sortConfig$sortableC = sortConfig.sortableColumns) === null || _sortConfig$sortableC === void 0 || (_sortConfig$sortableC = _sortConfig$sortableC.find(columnConfig => columnConfig.columnKey === columnName)) === null || _sortConfig$sortableC === void 0 ? void 0 : _sortConfig$sortableC.defaultSortDirection) || _SortDirection.SortDirection.ASCENDING;
    }
    setOrderBy(prevState => {
      const updatedState = {
        ...prevState
      };
      const secondarySortColumn = sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.secondarySortColumn;
      Object.keys(updatedState).forEach(key => {
        let resetValue = false;
        if (key !== columnName && updatedState[key] !== _SortDirection.SortDirection.NONE && key !== secondarySortColumn) {
          updatedState[key] = _SortDirection.SortDirection.NONE;
          resetValue = true;
        }
        if (secondarySortColumn && key === secondarySortColumn && secondarySortColumn !== columnName) {
          updatedState[key] = findDefaultSortDirection();
        } else if (secondarySortColumn === columnName && resetValue) {
          updatedState[secondarySortColumn] = _SortDirection.SortDirection.NONE;
        }
      });
      const currentSortableColumn = updatedState[columnName];
      if (currentSortableColumn === _SortDirection.SortDirection.NONE) {
        updatedState[columnName] = findDefaultSortDirection();
      } else if (currentSortableColumn === _SortDirection.SortDirection.DESCENDING) {
        updatedState[columnName] = _SortDirection.SortDirection.ASCENDING;
      } else {
        updatedState[columnName] = _SortDirection.SortDirection.DESCENDING;
      }
      if (onHeaderClick) {
        onHeaderClick(columnName, updatedState[columnName]);
      }
      return updatedState;
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-table ".concat(className, " mt-").concat(mt),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_TableHeader.default, {
    headerContent: headerContent,
    orderBy: orderBy,
    handleClick: handleClick,
    lookupTextFunction: lookupTextFunction,
    sortConfig: sortConfig,
    hasExpandableRows: bodyContent.some(rowContent => rowContent.expandedRow)
  }), /*#__PURE__*/_react.default.createElement(_TableBody.default, {
    tableBodyContent: sortedData,
    targetRowIndex: targetRowIndex,
    targetRowRef: targetRowRef,
    onExpandedRow: onExpandedRow
  }));
});